import React from 'react'
import InfoCard from './Card/InfoCard'

const Summary = ({ data }) => {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {data.map((d) => (
        <InfoCard
          key={d.title}
          title={d.title}
          value={d.value}
          icon={d.icon}
          accentColor={d.accentColor}
          note={d.note}
          noteValue={d.noteValue}
        />
      ))}
    </div>
  )
}

export default Summary
